import {
  DefaultVariants,
  ExperimentVariants,
  HOLDOUT,
} from "@outschool/experiments-shared";
import { useSession } from "@outschool/ui-auth";
import { useExperiment as useExperimentShared } from "@outschool/ui-experiments";

/**
 * Hook to get access to the experiment assignment and trigger function for an experiment.
 *
 * When working on UI experiments (experiments whose primary concern is showing different UI elements depending on the experiment assignment),
 * consider using the Experiment and ExperimentTriggerWrapper components instead of this hook.
 */
export default function useExperiment<
  Variants extends ExperimentVariants = DefaultVariants,
>(experimentName: string, defaultVariant: Variants = HOLDOUT as Variants) {
  const { currentUserHasLoaded } = useSession();
  return useExperimentShared<Variants>({
    currentUserHasLoaded,
    experimentName,
    defaultVariant,
  });
}
